import React from 'react';
import styled from '@emotion/styled';
import {
  SearchOutlineMediumIcon,
  token,
  TextPlaceholder,
} from '@ferreri/prever-component-lib';

type PublicationButtonSearchProps = {
  onClick?: () => void;
};

const PublicationButtonSearch = (props: PublicationButtonSearchProps) => (
  <ButtonWrapper type="button" onClick={props.onClick}>
    <SearchOutlineMediumIcon />
    <TextPlaceholder>Busque pelo benefício.</TextPlaceholder>
  </ButtonWrapper>
);

const ButtonWrapper = styled.button`
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${token.spacing.spacingXxSmall};
  background-color: ${token.colors.neutralXxLight};
  border-radius: ${token.borderRadius.borderRadiusPill};
  padding: 12px ${token.spacing.spacingSmall};
  box-sizing: border-box;
  width: 100%;

  svg {
    flex-shrink: 0;
  }
`;

export default PublicationButtonSearch;
